import { render, staticRenderFns } from "./ProvenanceHome.vue?vue&type=template&id=284efe61&scoped=true&"
import script from "./ProvenanceHome.vue?vue&type=script&lang=js&"
export * from "./ProvenanceHome.vue?vue&type=script&lang=js&"
import style0 from "./ProvenanceHome.vue?vue&type=style&index=0&id=284efe61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284efe61",
  null
  
)

export default component.exports